import toast from "react-hot-toast";

// Shared "delete successful" toast styling — a red circular X icon plus a
// light-red border/background tint, distinct from the default green
// checkmark used for add/edit toasts, so a destructive action reads
// differently at a glance. Used by every delete saga/handler so the design
// only needs to be defined once.
export const showDeleteToast = (message) =>
  toast.success(message || "Deleted Successfully", {
    icon: (
      <span
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 24,
          height: 24,
          borderRadius: 8,
          background: "linear-gradient(135deg, #f87171, #dc2626)",
          flexShrink: 0,
        }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path
            d="M6 6l12 12M18 6 6 18"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    ),
    style: {
      background: "#fff",
      color: "#111827",
      fontWeight: 600,
      border: "1px solid #fecaca",
      borderRadius: "12px",
      padding: "12px 16px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    },
  });
